import React from "react";
import { useTheme } from "@singlestore/fusion/theme-context";
import { cx } from "class-variance-authority";
import Highlight, {
    defaultProps,
    Language,
    PrismTheme,
} from "prism-react-renderer";
import dracula from "prism-react-renderer/themes/dracula";
import github from "prism-react-renderer/themes/github";

import "./SyntaxBlock.scss";

type SyntaxBlockProps = {
    code: string;
    className?: string;
    language?: Language;
};

// Single syntax block, for a given language
export function SyntaxBlock({
    code,
    className: blockClassName,
    language,
}: SyntaxBlockProps) {
    const { theme } = useTheme();

    const [syntaxBlockTheme, setSyntaxBlockTheme] =
        React.useState<PrismTheme>(github);

    React.useEffect(() => {
        if (theme === "dark") {
            setSyntaxBlockTheme(dracula);
        } else {
            setSyntaxBlockTheme(github);
        }
    }, [theme]);

    const classes = cx("syntax-block", blockClassName);

    let codeBlock = (
        <pre className={classes}>
            <code>{code}</code>
        </pre>
    );

    if (language) {
        codeBlock = (
            <Highlight
                {...defaultProps}
                code={code}
                language={language}
                theme={syntaxBlockTheme}
            >
                {({
                    className,
                    style,
                    tokens,
                    getLineProps,
                    getTokenProps,
                }) => (
                    <pre className={cx(classes, className)} style={style}>
                        {tokens.map((line, i) => (
                            // eslint-disable-next-line react/no-array-index-key
                            <div {...getLineProps({ line, key: i })} key={i}>
                                {line.map((token, j) => (
                                    <span
                                        {...getTokenProps({ token, key: j })}
                                        // eslint-disable-next-line react/no-array-index-key
                                        key={j}
                                    />
                                ))}
                            </div>
                        ))}
                    </pre>
                )}
            </Highlight>
        );
    }

    return codeBlock;
}
